angular.module('uti.skayo.onlinesale').controller('MainController', function (LoginService, $scope, $location, blockUI, SweetAlert, gettextCatalog) {
    $scope.getBodyClass = function(){
        if ($location.$$path == '/login')
            return 'login';
        return '';
    }
});
